import moment from "moment";
import { constants } from "@/services/constants";
import config from "../../config";

const getComingStatus = (status) => {
  switch (status) {
    case 0:
      return { color: "gray", label: "Черновой" };
    case 1:
      return { color: "orange", label: "Ожидание" };
    case 2:
      return { color: "green", label: "принято" };
    default:
      return { color: "red", label: "#ошибка" };
  }
};
const getOrderStatus = (status) => {
  switch (status) {
    case 0:
      return { color: "gray", label: "Черновой" };
    case 1:
      return { color: "orange", label: "Новые " };
    case 20:
      return { color: "green", label: "Принято" };
    case 30:
      return { color: "red", label: "Отменено" };
    default:
      return { color: "red", label: "#ошибка" };
  }
};
const getPaymentType = (status) => {
  switch (status) {
    case 1:
      return "Закуп";
    case 2:
      return "Продаж";
    default:
      return "Не указон";
  }
};
const getStatusUser = (status) => {
  switch (status) {
    case 10:
      return { color: "green", label: "#активно" };
    case 1:
      return { color: "orange", label: "#не подтверждено" };
    case 0:
      return { color: "red", label: "#не активно" };
    default:
      return { color: "red", label: "#ошибка" };
  }
};
const getStatus = (status) => {
  switch (status) {
    case 1:
      return { color: "green", label: "#активно" };
    case 0:
      return { color: "red", label: "#не активно" };
    default:
      return { color: "red", label: "#ошибка" };
  }
};
const getTransactionDebStatus = (status) => {
  switch (status) {
    case "paid":
      return { color: "green", label: "Оплачено" };
    case "pending":
      return { color: "orange", label: "Ожидает оплаты" };
    default:
      return { color: "orange", label: "Ожидает оплаты" };
  }
};
const getProjectType = (status) => {
  switch (status) {
    case "trade":
      return "Торговля";
    case "dcs":
      return "Дистрибуция";
    case "catering":
      return "Общепит";
    default:
      return "Не указано";
  }
};
const getTaskStatus = (status) => {
  switch (status) {
    case 1:
      return { color: "gray", label: "Новые" };
    case 2:
      return { color: "blue", label: "В процессе" };
    case 10:
      return { color: "green", label: "Завершенный" };
    case 11:
      return { color: "orange", label: "Отсроченный" };
    case 12:
      return { color: "purple", label: "Продленный" };
    case 20:
      return { color: "red", label: "Отменено" };
    default:
      return { color: "default", label: "Не указано" };
  }
};
const userRoles = [
  { value: "manager", label: "Менеджер" },
  { value: "operator", label: "Оператор" },
];
const getUserRole = (role) => {
  switch (role) {
    case "supervisor":
      return "Супервайзер";
    case "expeditor":
      return "Экспедитор";
    case "agent":
      return "Агент";
    case "warehouse":
      return "Завсклад";
    case "auditor":
      return "Аудитор";
    case "admin":
      return "Админ";
    case "manager":
      return "Менеджер";
    case "operator":
      return "Оператор";
    default:
      return "";
  }
};
const getMonths = (start, end) =>
  Array.from({ length: end.diff(start, "month") + 1 }).map((_, index) =>
    moment(start)
      .add(index, "month")
      .format("MM.YYYY"),
  );

const isEnableLang = (lang) => {
  switch (lang) {
    case "ru":
      return true;
    case "uz":
      return true;
    default:
      return false;
  }
};

const stringToCode = (element) => {
  const content = element.textContent;

  function toNode(iframeString) {
    const div = document.createElement("div");
    div.innerHTML = iframeString;
    return div;
  }
  const parent = element.parentNode;
  const childOembed = parent.querySelector("code");
  childOembed.replaceWith(toNode(content));
};
const formatDate = (date, format) => {
  let dt = new Date(date);
  let month = ("00" + (dt.getMonth() + 1)).slice(-2);
  let day = ("00" + dt.getDate()).slice(-2);
  let year = dt.getFullYear();
  let hours = ("00" + dt.getHours()).slice(-2);
  let minutes = ("00" + dt.getMinutes()).slice(-2);
  let seconds = ("00" + dt.getSeconds()).slice(-2);

  switch (format) {
    case "DD-MM-YYYY":
      return day + "-" + month + "-" + year;
    case "DD.MM.YYYY / HH:mm:ss":
      return (
        day +
        "." +
        month +
        "." +
        year +
        " / " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    case "DD/MM/YYYY HH:mm:ss":
      return (
        day +
        "/" +
        month +
        "/" +
        year +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    case "DD.MM.YYYY / HH:mm":
      return day + "." + month + "." + year + " / " + hours + ":" + minutes;
    case "DD.MM.YYYY HH:mm":
      return day + "." + month + "." + year + " " + hours + ":" + minutes;
    case "HH:mm / DD.MM.YYYY":
      return hours + ":" + minutes + " / " + day + "." + month + "." + year;
    case "HH:mm":
      return hours + ":" + minutes;
    default:
      return day + "." + month + "." + year;
  }
};
function convertToReadable(number) {
  function isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }

  let newValue;
  if (isFloat(Number(number))) {
    newValue = number.toString().split(".");
    newValue[0] = newValue[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    newValue = newValue.join(".");
  } else {
    newValue = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  return newValue;
}
function validateIsEmpty(value) {
  let error;
  if (!value || /^\s*$/.test(value)) {
    error = "Required";
  }
  return error;
}
const isLetter = (value) => {
  return (
    (value.charCodeAt(0) >= 97 && value.charCodeAt(0) <= 122) ||
    (value.charCodeAt(0) >= 65 && value.charCodeAt(0) <= 90)
  );
};
const checkLetter = (value) => {
  return (
    (value.charCodeAt(0) >= 97 && value.charCodeAt(0) <= 122) ||
    (value.charCodeAt(0) >= 65 && value.charCodeAt(0) <= 90) ||
    value.charCodeAt(0) === 46
  );
};
const checkNumber = (value) => {
  if (value) {
    if (typeof value !== "number" && typeof value === "string") {
      return +value.replaceAll(" ", "");
    } else {
      return +value;
    }
  } else {
    return null;
  }
};
const getValue = (value) => {
  if (value) {
    let result;
    value = String(value);
    let lastChar = value.slice(-1);

    if (lastChar.charCodeAt(0) !== 46) {
      if (!isLetter(lastChar)) {
        result = value
          ? Number(value.replaceAll(" ", ""))
              .toFixed(1)
              .replace(/\d(?=(\d{3})+\.)/g, "$& ")
              .replaceAll(".0", "")
          : "";
      }
    } else {
      result = value
        ? Number(value.replaceAll(" ", ""))
            .toFixed(1)
            .replace(/\d(?=(\d{3})+\.)/g, "$& ")
            .replaceAll(".0", ".")
        : "";
    }
    if (value.toString().includes(".") && !checkLetter(lastChar)) {
      result = value;
    }
    if (result === "Infinity" || result === "NaN") {
      result = null;
    }

    return result;
  }
};
const getDaysBetweenDates = (startDate, endDate, format = "YYYY-MM-DD") => {
  const now = startDate.clone(),
    dates = [];

  while (now.isSameOrBefore(endDate)) {
    dates.push(now.format(format));
    now.add(1, "days");
  }
  return dates;
};

const getGroupType = (groupType) => {
  if (groupType === constants.GROUP_TYPE_CATEGORY) return "категорий";
  else if (groupType === constants.GROUP_TYPE_PRODUCT) {
    return "продуктов";
  } else if (groupType === constants.GROUP_TYPE_INVENTORY) {
    return "инвентаря";
  }
};

const getStorageType = (storageType) => {
  const found = constants.storageTypes.find(
    (item) => item.value === storageType,
  );
  return found ? found.label : "";
};

const getCurrencyTitle = (code) => {
  switch (code) {
    case "uzs":
      return "UZS";
    case "usd":
      return "USD";
    case "rub":
      return "RUB";
    case "kzt":
      return "KZT";
    case "aed":
      return "AED";
    case "tjs":
      return "TJS";
    default:
      return "";
  }
};

const getPaymentTypeLabel = (type) => {
  switch (type) {
    case "cash":
      return "Наличный";
    case "credit_card":
      return "Карта";
    case "bank_account":
      return "Перечисления";
    case "payme":
      return "Пайме";
    case "octo":
      return "Octo";
    case "hamkorbank":
      return "HamkorBank";
    default:
      return "";
  }
};
const getCurrencyLabel = (currencyCode) => {
  switch (currencyCode) {
    case "uzs":
      return "сум";
    case "kzt":
      return "тенге";
    case "aed":
      return "dirxam";
    case "tjs":
      return "сомони";
    default:
      return "сум";
  }
};
const getStorageLabelByType = (type) => {
  switch (type) {
    case config.CATEGORY_MATERIAL:
      return "Сырьё";
    case config.CATEGORY_PRODUCT:
      return "Реализация";
    case config.CATEGORY_HALF_FINISHED:
      return "Полуфабрикат";
    case config.CATEGORY_FINISHED:
      return "Готовый продуктов";
    case config.CATEGORY_DISH:
      return "Блюда";
    case config.CATEGORY_TELEGRAM:
      return "Продукт Б/У";
    default:
      return "-";
  }
};

const getUserType = (type) => {
  switch (type) {
    case 1:
      return "Сотрудник";
    case 2:
      return "Поставщик";
    case 3:
      return "Клиент";
    case 4:
      return "Другие";
    default:
      return "";
  }
};

const formatPhone = (phone) => {
  if (!phone) return "-";
  const digits = String(phone).replace(/\D/g, "");
  if (digits.startsWith("998") && digits.length === 12) {
    return `+998 ${digits.slice(3, 5)} ${digits.slice(5, 8)} ${digits.slice(
      8,
      10,
    )} ${digits.slice(10, 12)}`;
  }
  if (digits.length > 0) {
    return phone.startsWith("+") ? phone : `+${digits}`;
  }
  return phone;
};

const getServiceStatus = (id) => {
  switch (id) {
    case 1:
      return { color: "blue", label: "Ежемесячная оплата" };
    case 2:
      return { color: "purple", label: "Установка" };
    case 3:
      return { color: "gray", label: "Интеграция с налоговой" };
    case 4:
      return { color: "green", label: "Онлайн-меню" };
    case 5:
      return { color: "orange", label: "ЗимЛинк" };
    case 6:
      return { color: "teal", label: "Телеграм-бот" };
    case 7:
      return { color: "black", label: "Склад" };
    case 8:
      return { color: "red", label: "Эквайринг Hamkorbank" };
    default:
      return { color: "gray", label: "Неизвестно" };
  }
};

export default {
  getTransactionDebStatus,
  getCurrencyTitle,
  getProjectType,
  getComingStatus,
  getStorageType,
  getGroupType,
  getMonths,
  userRoles,
  getUserRole,
  getDaysBetweenDates,
  isEnableLang,
  formatDate,
  stringToCode,
  getStatus,
  getPaymentType,
  convertToReadable,
  validateIsEmpty,
  getValue,
  checkNumber,
  getStatusUser,
  getPaymentTypeLabel,
  getTaskStatus,
  getCurrencyLabel,
  getStorageLabelByType,
  getOrderStatus,
  getUserType,
  getServiceStatus,
  formatPhone,
};
